import React, { useState } from "react";

import AppointmentModal from "../../modals/appointment/AppointmentModal";
import InputField from "../../common/InputField";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { Typography, Box } from "@mui/material";
import { PrimaryButton } from "../../common/Buttons";
import { toast } from "react-hot-toast";
import { postAppointment } from "../../services/appointment";
import { useTranslation } from "react-i18next";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
import { useSelector } from "react-redux";

const AppointmentForm = (props) => {
  const { t } = useTranslation();
  const uID = getUserIdFromLocalStorage();
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const state = useSelector((state) => state.user);
  const validate = Yup.object({
    name: Yup.string().required(t("required")).max(50, t("max-50-characters")),

    email: Yup.string().email(t("Must-be-ValidEmail")).required(t("required")),
    dob: Yup.string()
      .required(t("required"))
      .test("DATE", t("choose-between-1930"), (value) => {
        if (value) {
          let [yyyy] = value ? value.split("-") : [];
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [, , curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),

    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .typeError(t("in-valid"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      ),

    freeText: Yup.string().max(1000, t("max-1000-characters")),
  });

  const handleSubmit = async (values, resetForm) => {
    setLoading(true);
    const result = await postAppointment(values, uID);
    if (result?.success) {
      setLoading(false);
      handleOpenModal();
      resetForm();
    }
  };
  const handleOpenModal = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        mt: 5,
        paddingX: "18rem",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        color="color.magentaDark2"
      >
        {t("appointment-heading")}
      </Typography>

      <Typography
        sx={{ mt: 5 }}
        variant="p"
        paragraph
        align="center"
        color="color.magentaDark2"
      >
        {t("appointment-text")}
      </Typography>
      <Formik
        initialValues={{
          name: localStorage.getItem("userName") || "",
          email: state.email || "",
          dob: new Date().toISOString().slice(0, 10),
          phone: "",
          freeText: "",
        }}
        enableReinitialize
        validationSchema={validate}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values, resetForm);
        }}
      >
        {(formik) => (
          <Form>
            <InputField
              fullWidth
              variant="standard"
              placeholder="John"
              label={t("input-1")}
              name="name"
              type="text"
              disabled
            />

            <InputField
              fullWidth
              variant="standard"
              placeholder="demo@gmail.com"
              label={t("input-3")}
              name="email"
              type="email"
              disabled
            />
            <InputField
              fullWidth
              variant="standard"
              placeholder="2842394789"
              label={t("input-4")}
              name="phone"
              type="string"
              InputLabelProps={{ shrink: true }}
              disabled
            />
            <InputField
              fullWidth
              variant="standard"
              label={t("input-23")}
              name="freeText"
              type="string"
              multiline
              rows={2}
              maxRows={4}
              InputLabelProps={{ shrink: true }}
            />
            <Box textAlign="center" paddingBottom="15px">
              <PrimaryButton
                fullWidth={false}
                textTransform="none"
                title={t("req-appointment")}
                borderRadius="13px"
                padding="0.7rem 1.5rem"
                margin="4rem 0 0 0"
                color="#444561"
                boxShadow={-1}
                click={formik.handleSubmit}
                isLoading={loading}
                disabled={loading}
                bgColor="#E8D7E5"
              />
            </Box>
          </Form>
        )}
      </Formik>
      {isModalOpen && (
        <AppointmentModal open={true} handleClose={handleCloseModal} />
      )}
    </Box>
  );
};

export default AppointmentForm;
